import makeStyles from '@material-ui/core/styles/makeStyles';
import { getDate } from '../../../../../../@casino/lib/getDate';

const useStyles = makeStyles(() => ({
    arrow: {
        fill: '#fff', width: 10, height: 10,
    },
    wrapTitle: {
        paddingLeft: 8,
        paddingBottom: '6px',
        marginTop: 20,
        paddingTop: '4px',
        marginBottom: '8px',
        borderBottom: '1px solid #ccc',
        width: '97%',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: 12,
    },
    title: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '14px',
        lineHeight: '17px',
        userSelect: 'none',
        fontFamily: 'PT Sans,sans-serif',
        color: '#fff',
    }
}));

const getRows = (rezymeArr) => {
    return rezymeArr.map((item) => {
        return {
            bet_id: item.bet_id,
            date: item?.date ? getDate(item.date) : '-',
            amount: new Intl.NumberFormat('ru-RU').format(item.amount) + '₽',
            type: item?.type
        }
    })
}

const columns = [
    { id: 'bet_id', label: 'Bet ID'},
    { id: 'date', label: 'Дата'},
    { id: 'amount', label: 'Сумма'},
    { id: 'type', label: 'Тип'},
];

export {
    useStyles,
    columns,
    getRows
}